import { ContinuousDrillingObligationBase } from './base/continuous-drilling-obligation-base';

export class ContinuousDrillingObligation extends ContinuousDrillingObligationBase { }